module.exports = __webpack_public_path__ + "static/media/vTex_icon.1ad7a52b.png";